import { render, staticRenderFns } from "./PriceNegotiations.vue?vue&type=template&id=84d03da6&scoped=true&"
import script from "./PriceNegotiations.vue?vue&type=script&lang=js&"
export * from "./PriceNegotiations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d03da6",
  null
  
)

export default component.exports